import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Marker, Pane, Popup } from "react-leaflet";
import { selectLicenseList, setCurrentDetails } from "../../api/redux";
import { Button } from "antd";
import DetailsModal from "./DetailsModal";
import { renderToStaticMarkup } from "react-dom/server";
import L, { divIcon } from "leaflet";
import CurrencyFormat from "react-currency-format";
import { oppLog } from "../../api/crud";

export default () => {
  const [show, setShow] = React.useState(false);
  const [current, setCurrent] = React.useState({});

  const state = useSelector(selectLicenseList);

  const closeHandler = () => {
    setShow(false);
    setCurrent({});
    dispatch(setCurrentDetails(null));
    setTimeout(() => {
      dispatch(setCurrentDetails({}));
    }, 100);
  };

  const iconMarkup = renderToStaticMarkup(<i className=" fa fa-trash fa-3x" />);
  const customMarkerIcon = divIcon({
    html: iconMarkup,
  });

  const markerGenerator = (iconUrl) => {
    if(iconUrl){
      const iconUrlCondition =   iconUrl &&
      `http://atlas-kerman.arian.co.ir${
        iconUrl[iconUrl.length - 1] === "/"
          ? iconUrl.substring(0, iconUrl.length - 2)
          : iconUrl}`
  
      const leafletIcon = L.divIcon({
        className: "custom-div-icon",
        html: `<div style='background-color:#0879fa;' class='marker-pin'></div><img class="icon-img" src='${
            iconUrlCondition
          
        }' />`,
        iconSize: [35, 55],
        iconAnchor: [12, 50],
      });
     
  
      return leafletIcon;
    }
  };

  const dispatch = useDispatch();

  return (
    <>
      {state.oppurtunities &&
        state.oppurtunities.map((el) => {
          if (el.point) {
            const option = {};
            if (el.Sector?.marker) {
              option.icon = markerGenerator(el?.Sector?.marker);
            }
            return (
              <Pane style={{ zIndex: 5999999999 }}>
                <Marker
                  position={el?.point?.coordinates}
                  {...option}
                  style={{ zIndex: 59999999999999999 }}
                  zIndexOffset={59000000000000}
                >
                  <Popup style={{ minWidth: "3rem", width: "auto" }}>
                    <div className="d-flex-column gap-5 text-right">
                      {el.title && (
                        <h6 className="mb-3 lh-30">عنوان طرح: {el.title}</h6>
                      )}
                      {el.amount && (
                        <h6 className="mb-3 lh-30">
                          مبلغ سرمایه گذاری:{" "}
                          <CurrencyFormat
                            value={el.amount}
                            displayType={"text"}
                            thousandSeparator={true}
                          />{" "}
                          <span className="mx-1">میلیارد ریال</span>
                        </h6>
                      )}
                      {el.Township && (
                        <h6 className="mb-3 lh-30">
                          شهرستان پیشنهادی: {el.Township?.title}
                        </h6>
                      )}
                      {el.recommender && (
                        <h6 className="mb-3 lh-30">
                          پیشنهاد دهنده: {el.recommender}
                        </h6>
                      )}
                      {/* {el.Sector && (
                        <h6 className="mb-3 lh-30">
                          بخش سرمایه گذاری: {el.Sector?.title}
                        </h6>
                      )}
                      {el.ActivityGroup && (
                        <h6 className="mb-3 lh-30">
                          گروه فعالیت: {el.ActivityGroup?.title}
                        </h6>
                      )}
                      {el.Product && (
                        <h6 className="mb-3 lh-30">
                          محصول: {el.Product?.title}
                        </h6>
                      )} */}

                      <div className="col-12 p-0">
                        <Button
                          className="w-100"
                          style={{ height: "2rem", borderRadius: "5px" }}
                          onClick={() => {
                            dispatch(setCurrentDetails(el));
                            oppLog({ opportunityId: el?.id });
                            setShow(true);
                          }}
                        >
                          مشاهده جزییات
                        </Button>
                      </div>
                    </div>
                  </Popup>
                </Marker>
              </Pane>
            );
          }
        })}
      <DetailsModal onClose={closeHandler} data={current} show={show} />
    </>
  );
};
